import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const EmergencyContactsPage = () => {
  const columns = [
    { key: 'name', label: 'Contact Name' },
    { key: 'organization', label: 'Organization' },
    { key: 'type', label: 'Type' },
    { key: 'phone', label: 'Phone' },
    { key: 'email', label: 'Email' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'name', label: 'Contact Name', type: 'text', required: true },
    { key: 'organization', label: 'Organization', type: 'text', required: true },
    { key: 'type', label: 'Type', type: 'select', required: true, options: [
      { value: 'Fire/Rescue', label: 'Fire/Rescue' },
      { value: 'Police', label: 'Police' },
      { value: 'Medical', label: 'Medical' },
      { value: 'Government', label: 'Government' },
      { value: 'Utility', label: 'Utility' },
      { value: 'Shelter', label: 'Shelter' },
      { value: 'Other', label: 'Other' },
    ]},
    { key: 'phone', label: 'Phone', type: 'text', required: true },
    { key: 'email', label: 'Email', type: 'email', required: false },
    { key: 'address', label: 'Address', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', name: 'Houston Fire Department', organization: 'City of Houston', type: 'Fire/Rescue', phone: '911', email: 'hfd@houston.gov', active: 'Yes' },
    { id: '2', name: 'Houston Police Department', organization: 'City of Houston', type: 'Police', phone: '911', email: 'hpd@houston.gov', active: 'Yes' },
    { id: '3', name: 'Harris County OEM', organization: 'Harris County', type: 'Government', phone: '(713) 881-3100', email: 'oem@harriscounty.gov', active: 'Yes' },
    { id: '4', name: 'Memorial Hermann EMS', organization: 'Memorial Hermann', type: 'Medical', phone: '(713) 704-4000', email: 'ems@memorialhermann.org', active: 'Yes' },
    { id: '5', name: 'Red Cross Houston', organization: 'American Red Cross', type: 'Shelter', phone: '(713) 526-8300', email: 'houston@redcross.org', active: 'Yes' },
    { id: '6', name: 'CenterPoint Energy', organization: 'CenterPoint', type: 'Utility', phone: '(800) 332-7143', email: 'outages@centerpointenergy.com', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Emergency Preparedness Contacts"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Contact"
      formFields={formFields}
      apiEndpoint="/setup/emergency-contacts"
    />
  );
};

export default EmergencyContactsPage;
